import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PerformanceReportTable = ({ reports }) => {
  const [sortField, setSortField] = useState('date');
  const [sortDirection, setSortDirection] = useState('desc');

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };

  const sortedReports = [...reports]?.sort((a, b) => {
    const aValue = a?.[sortField];
    const bValue = b?.[sortField];
    
    if (sortDirection === 'asc') {
      return aValue > bValue ? 1 : -1;
    }
    return aValue < bValue ? 1 : -1;
  });

  const SortIcon = ({ field }) => {
    if (sortField !== field) return <Icon name="ChevronsUpDown" size={14} className="opacity-40" />;
    return sortDirection === 'asc' ? 
      <Icon name="ChevronUp" size={14} /> : 
      <Icon name="ChevronDown" size={14} />;
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th 
                className="px-4 md:px-6 py-3 md:py-4 text-left cursor-pointer hover:bg-muted/80 transition-smooth"
                onClick={() => handleSort('date')}
              >
                <div className="flex items-center gap-2 text-xs md:text-sm font-medium text-foreground">
                  Date
                  <SortIcon field="date" />
                </div>
              </th>
              <th 
                className="px-4 md:px-6 py-3 md:py-4 text-left cursor-pointer hover:bg-muted/80 transition-smooth"
                onClick={() => handleSort('campaign')}
              >
                <div className="flex items-center gap-2 text-xs md:text-sm font-medium text-foreground">
                  Campaign
                  <SortIcon field="campaign" />
                </div>
              </th>
              <th 
                className="px-4 md:px-6 py-3 md:py-4 text-right cursor-pointer hover:bg-muted/80 transition-smooth"
                onClick={() => handleSort('impressions')}
              >
                <div className="flex items-center justify-end gap-2 text-xs md:text-sm font-medium text-foreground">
                  Impressions
                  <SortIcon field="impressions" />
                </div>
              </th>
              <th 
                className="px-4 md:px-6 py-3 md:py-4 text-right cursor-pointer hover:bg-muted/80 transition-smooth"
                onClick={() => handleSort('conversions')}
              >
                <div className="flex items-center justify-end gap-2 text-xs md:text-sm font-medium text-foreground">
                  Conversions
                  <SortIcon field="conversions" />
                </div>
              </th>
              <th 
                className="px-4 md:px-6 py-3 md:py-4 text-right cursor-pointer hover:bg-muted/80 transition-smooth"
                onClick={() => handleSort('revenue')}
              >
                <div className="flex items-center justify-end gap-2 text-xs md:text-sm font-medium text-foreground">
                  Revenue
                  <SortIcon field="revenue" />
                </div>
              </th>
              <th 
                className="px-4 md:px-6 py-3 md:py-4 text-right cursor-pointer hover:bg-muted/80 transition-smooth"
                onClick={() => handleSort('roi')}
              >
                <div className="flex items-center justify-end gap-2 text-xs md:text-sm font-medium text-foreground">
                  ROI
                  <SortIcon field="roi" />
                </div>
              </th>
              <th className="px-4 md:px-6 py-3 md:py-4 text-right">
                <span className="text-xs md:text-sm font-medium text-foreground">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {sortedReports?.map((report, index) => (
              <tr key={index} className="hover:bg-muted/30 transition-smooth">
                <td className="px-4 md:px-6 py-3 md:py-4">
                  <span className="text-xs md:text-sm text-foreground whitespace-nowrap">{report?.date}</span>
                </td>
                <td className="px-4 md:px-6 py-3 md:py-4">
                  <span className="text-xs md:text-sm font-medium text-foreground">{report?.campaign}</span>
                </td>
                <td className="px-4 md:px-6 py-3 md:py-4 text-right">
                  <span className="text-xs md:text-sm text-foreground whitespace-nowrap">{report?.impressions}</span>
                </td>
                <td className="px-4 md:px-6 py-3 md:py-4 text-right">
                  <span className="text-xs md:text-sm text-foreground whitespace-nowrap">{report?.conversions}</span>
                </td>
                <td className="px-4 md:px-6 py-3 md:py-4 text-right">
                  <span className="text-xs md:text-sm font-semibold text-foreground whitespace-nowrap">{report?.revenue}</span>
                </td>
                <td className="px-4 md:px-6 py-3 md:py-4 text-right">
                  <span className={`text-xs md:text-sm font-semibold whitespace-nowrap ${
                    parseFloat(report?.roi) >= 0 ? 'text-success' : 'text-error'
                  }`}>
                    {report?.roi}
                  </span>
                </td>
                <td className="px-4 md:px-6 py-3 md:py-4 text-right">
                  <Button variant="ghost" size="sm" iconName="Download" iconPosition="left">
                    Export
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PerformanceReportTable;